export class LhlpMapConfig {
    public StatusStyles: Array<LhlpStatusLookup>;  
    public TypeStyles: Array<LhlpTypeLookup>;

    public SubAreaLayerTitle: string;

    public CreateAssetUrl: string;
    public EditAssetPointUrl: string;
    public EditAssetPolygonUrl: string;

    public constructor() {
        this.StatusStyles = [ new LhlpStatusLookup() ];
        this.TypeStyles = [ new LhlpTypeLookup() ];
    }
}

export class LhlpStatusLookup {
    public StatusId: string;
    public StatusColour: string;
}

export class LhlpTypeLookup {
    public TypeId: string;
    public TypeCharacter: string;
    public LayerName: string;
    public LayerHelpText: string;
    public LayerHelpUrl: string;
}